export default {
    brand_overview_title: 'Brand',
    brand_overview_actions: 'Actions',
    brand_overview_tab_dealers: 'Dealers',
    brand_overview_tab_message_templates: 'Message Templates',
    brand_overview_code: 'Code',
    brand_overview_title: 'Title',
    brand_overview_domains: 'Domains',
    brand_overview_username: 'Username',
    brand_overview_opened_at: 'Opened at',
    brand_overview_status: 'Status',
    brand_overview_package: 'Package',
    brand_overview_devices: 'Devices',
    brand_overview_brand: 'Brand',
    brand_overview_crm: 'Salesforce Id',
    brand_overview_activities: 'Activities',
    brand_overview_keysfobs: 'DriverID Tags',
    brand_overview_user: 'Users',

    brand_overview_edit_brand: 'Edit Brand',
    brand_overview_reset_legacy_user: 'Reset Brand Password',
    brand_overview_change_brand_status: 'Change Brand Status',
    brand_overview_change_brand_brand: 'Change Brand Brand',
    brand_overview_import_and_assign: 'Import and Assign',
    brand_overview_reset_cognito_user: 'Reset Cognito Authentication',
    brand_overview_device_models: 'Device Models',
    brand_overview_part_numbers: 'Part Numbers',
    brand_overview_unit_types: 'Unit Types',
    brand_overview_active_devices: 'Active Devices',
    brand_overview_system_alert_logs: 'System Alert Logs',
    brand_overview_scheduled_reports: 'Scheduled Reports',
    brand_overview_email: 'Email',
    brand_overview_export_logs: 'Export Logs',
    brand_overview_terms_conditions: 'Verify Terms and Conditions',
    brand_overview_scheduled_actions: 'Schedule Actions',
    brand_overview_change_username: 'Change Username',

    brand_overview_master_company: 'Master Company',
    brand_overview_tab_accounts: "Accounts",
    brand_overview_tab_packages: "Packages",
};

